<template>
    <div class="hub-sales-performance">
        <b-card no-body>
            <b-card-header class="border-0 px-3 py-2">
                <b-row align-v="center">
                    <b-col cols="9">
                        <h3 class="mb-0">
                            Hub Sales Performance
                        </h3>
                    </b-col>
                    <b-col cols="3">
                        <el-select v-model="sort_by" placeholder="Sort By">
                            <el-option value="Actual RP">Actual RP</el-option>
                            <el-option value="Pre-Revenue">Pre-Revenue</el-option>
                            <el-option value="Target Sales">Target Sales</el-option>
                        </el-select>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-container>
                <div id="chart">
                    <apexchart type="line" height="350" :options="chartOptions" :series="series"></apexchart>
                </div>
            </b-container>
        </b-card>
    </div>
</template>
<script>
import { Select, Option } from 'element-ui'
import VueApexCharts from 'vue-apexcharts';

export default {
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        "apexchart": VueApexCharts,
    },
    data() {
        return {
            sort_by: '',
            series: [{
                name: 'Completed',
                type: 'column',
                data: [23000, 11000, 22000, 27000, 13000, 22000, 37000, 21000, 44000, 22000, 30000]
            }, {
                name: 'Pending',
                type: 'area',
                data: [44000, 55000, 41000, 67000, 22000, 43000, 21000, 41000, 56000, 27000, 43000]
            }, {
                name: 'Target Sales',
                type: 'line',
                data: [30000, 25000, 36000, 30000, 45000, 35000, 64000, 52000, 59000, 36000, 39000]
            }],
            chartOptions: {
                chart: {
                    height: 350,
                    type: 'line',
                    stacked: false,
                },
                stroke: {
                    width: [0, 2, 5],
                    curve: 'straight'
                },
                plotOptions: {
                    bar: {
                        columnWidth: '50%'
                    }
                },
                fill: {
                    opacity: [0.85, 0.25, 1],
                    gradient: {
                        inverseColors: false,
                        shade: 'light',
                        type: "vertical",
                        opacityFrom: 0.85,
                        opacityTo: 0.55,
                        stops: [0, 100, 100, 100]
                    }
                },
                labels: ['01/01/2023', '02/01/2023', '03/01/2023', '04/01/2023', '05/01/2023', '06/01/2023', '07/01/2023',
                '08/01/2023', '09/01/2023', '10/01/2023', '11/01/2023'
                ],
                markers: {
                    size: 0
                },
                xaxis: {
                    type: 'datetime'
                },
                yaxis: {
                    min: 0,
                    labels: {
                        formatter: (value) => { 
                            if (value >= 1000) {
                                return (value / 1000).toFixed(0) + 'k';
                            }
                            return value.toLocaleString(undefined, { minimumFractionDigits: 2 });
                         },
                    }
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                    y: {
                        formatter: function (y) {
                        if (typeof y !== "undefined") {
                            return 'RM ' + y.toLocaleString(undefined, {minimumFractionDigits: 2});
                        }
                        return y;
                    
                        }
                    }
                }
            },
        }
    },
}
</script>